<template>
  <article class="product-teaser">
    <a
      class="product-teaser__link"
      :href="product.link"
      :class="{'product-teaser__link--grid' : type == 'grid'}"
    >
      <div class="product-teaser__container">
        <sale-flash
          v-if="product.show_price"
          :product="product"
          :teaser-mode="true"
          :sale-type="'teaser'"
        />
        <div class="product-teaser__image-container">
          <img
            v-if="product.image"
            v-lazy="product.image.productTeaser"
            class="product-teaser__image"
            :srcset="product.image.productTeaser + ' 1x, ' + product.image.productTeaserX2 + ' 2x'"
            alt=""
          >
          <img
            v-else
            v-lazy="$modeoL10n.placeholder_img"
            class="product-teaser__image"
            alt=""
          >
          <span
            v-if="product.brand.modeo_plus && !product.sale"
            class="modeo-plus"
            aria-label="Modeo+"
          >+</span>
          <product-sticker :id="product.sticker" />
        </div>
        <h3 class="product-teaser__heading">
          <span
            v-if="product.brand.modeo_plus"
            class="modeo-plus"
          >{{ product.brand.modeo_plus.name }}</span>
          <!-- eslint-disable vue/no-v-html -->
          <span
            v-if="product.brand && product.brand.name"
            class="product-teaser__brand"
            v-html="$sanitize(product.brand.name)"
          />
          <!-- eslint-enable vue/no-v-html -->
          {{ product.name }}
        </h3>
        <div class="product-teaser__price price">
          <div
            v-if="hasPrice"
            class="product-teaser__price-amount-container price-amount-container price-amount-container--small"
          >
            <span
              v-if="product.variations_has_different_prices"
              class="starting-from"
            >alk.</span>
            <span
              class="product-teaser__price-amount price-amount"
              :class="{ 'price-amount--ins': product.price_from_with_add_ons != product.regular_price_from_with_add_ons }"
            >
              <price
                :price-without-tax="product.prices_without_tax.price_from_with_add_ons"
                :price-with-tax="product.prices_with_tax.price_from_with_add_ons"
              />
            </span>
            <span
              v-if="product.price_from_with_add_ons != product.regular_price_from_with_add_ons"
              class="product-teaser__price-amount price-amount price-amount--del"
            >
              <price
                :price-without-tax="product.prices_without_tax.regular_price_from_with_add_ons"
                :price-with-tax="product.prices_with_tax.regular_price_from_with_add_ons"
              />
            </span>
          </div>
          <div
            class="price-details price-details--small"
            :class="{'price-details--no-price' : !hasPrice}"
          >
            <span
              v-if="hasPrice"
              class="product-teaser__tax tax"
              :class="{ 'tax--highlight': (product.outlet && !$store.getters.showPricesWithVat) }"
            >{{ $modeoL10n.vat }} {{ $store.getters.displayVat }}</span>
            <span
              class="btn btn--buy btn--buy-small"
              :class="{'btn--buy-no-price' : !hasPrice}"
            >{{ product.disable_buying || !hasPrice ? $modeoL10n.check_out : $modeoL10n.buy }}</span>
          </div>
        </div>
      </div>
    </a>
  </article>
</template>

<script>
import SaleFlash from './sale-flash.vue';
import ProductSticker from './product-sticker.vue';

export default {
    components: {
        SaleFlash,
        ProductSticker,
    },
    props: {
        product: {
            type: Object,
            default: function () {
                return {};
            },
        },
        type: {
            type: String,
            default: '',
        },
    },
    computed: {
        hasPrice() {
            return this.product.price_from_with_add_ons && this.product.show_price;
        },
    },
}
</script>
